import Vue from "vue";
export const vueEvent = new Vue();